import type { CurrentCalendarEventResponse } from '@ai-meeting/shared'
import { apiClient } from './api'

const NO_EVENT: CurrentCalendarEventResponse = { event: null, projectKey: null }

/**
 * Ask which meeting the reader is in, so the Create Meeting form can name
 * itself after it and file it under a project (BRAI-745).
 *
 * Never rejects. The form is the point, and it opens with `Meeting#N` and an
 * empty Project whether or not this answers — a calendar nobody connected and
 * an AI service having a bad minute look the same from here.
 *
 * @returns The event covering now, or `{ event: null }` when there is none.
 */
export function fetchCurrentCalendarEvent(): Promise<CurrentCalendarEventResponse> {
  return apiClient
    .get<CurrentCalendarEventResponse>('/api/calendar/current-event')
    .then(({ data }) => data ?? NO_EVENT)
    .catch(() => NO_EVENT)
}
